import React from 'react';

import Base from 'app/views/base';

import CarrierAccounts from 'app/collections/carrier_accounts';
import CarrierTypes from 'app/collections/carrier_types';

import PageHeader from 'app/components/page_header_react';
import CarrierAccountListView from 'app/components/pages/carrier_accounts/carrier_accounts/list';
import FilterView from 'app/components/pages/carrier_accounts/filter';
import CarrierTypeListView from 'app/components/pages/carrier_accounts/add_carrier_account/list';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'carrier-account-page',

  events: {},

  initialize() {
    this.collection = new CarrierAccounts([]);
    this.availableCarrierTypes = new CarrierTypes([]);

    this.addReactComponent('header', <PageHeader name="Carrier Accounts" />);
    this.addSubview('carrierAccountFilter', '#carrier_account_filter', new FilterView({
      collection: this.collection,
      placeholder: 'Filter by Carrier Name, Account ID, or Description',
    }));
    this.addSubview('carrierAccountList', '#carrier_account_list', new CarrierAccountListView({ collection: this.collection }));

    this.addSubview('carrierTypeFilter', '#carrier_type_filter', new FilterView({
      collection: this.availableCarrierTypes,
      placeholder: 'Filter by Name',
    }));
    this.addSubview('carrierTypeList', '#carrier_type_list', new CarrierTypeListView({
      collection: this.availableCarrierTypes,
      carrierAccounts: this.collection,
    }));

    this.listenTo(this.collection, 'sync', this.refetchCarrierTypes);
    this.listenTo(this.collection, 'remove', this.refetchCarrierTypes);
    this.collection.fetch({ reset: true });
  },

  refetchCarrierTypes() {
    this.availableCarrierTypes.fetch({ reset: true });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/index.jsx